import styled from 'styled-components';

export const PaymentModal = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
`;

export const CardContainer = styled.div`
	position: relative;
	margin-top: 44px;
	margin-bottom: 20px;
`;

export const Image = styled.img`
	max-width: 150px;
	min-width: 150px;
	width: 150px;
`;

export const AlertImage = styled.img`
	position: absolute;
	right: -35px;
	top: -23px;
	width: 89px;
	max-width: 89px;
	min-width: 89px;
`;

export const Loader = styled.div`
	position: absolute;
	right: -15px;
	top: -13px;
	width: 49px;
	height: 49px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-right: 10px;
	background: linear-gradient(243.18deg, #6467f0 0%, #402c86 102.28%);
	box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
	border-radius: 50px;
`;

export const Link = styled.a`
	width: 100%;
`;

export const Title = styled.div`
	font-weight: 700;
	font-size: 20px;
	line-height: 23px;
	text-align: center;
	letter-spacing: 0.304706px;
	color: #1a1a1a;
	margin-bottom: 10px;
`;

export const SkipWrapper = styled.div`
	margin-top: 20px;
`;

export const Text = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 21px;
	text-align: center;
	letter-spacing: 0.304706px;
	color: #1a1a1a;
	margin-bottom: 20px;
	min-height: 48px;
`;

export const ButtonsContainer = styled.div<{ isLoading?: boolean }>`
	width: 100%;
	opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
`;
